import React from 'react';
import PropTypes from 'prop-types';
import LibraryFrame from './LibraryFrame';

const LibraryProvider = (props) => (
    <LibraryFrame
        isPicker={false}
        notify={props.notify}
        openContent={props.openContent}
        openFileViewer={props.openFileViewer} />
);
LibraryProvider.propTypes = {
    notify: PropTypes.func.isRequired,
    openContent: PropTypes.func.isRequired,
    openFileViewer: PropTypes.func.isRequired,
};

const LibraryPicker = (props) => (
    <LibraryFrame
        isPicker={true}
        pickerPreFilters={props.pickerPreFilters}
        onPickFiles={props.onPickFiles}
    />
);
LibraryPicker.propTypes = {
    pickerPreFilters: PropTypes.object.isRequired,
    onPickFiles: PropTypes.func.isRequired,
};

export { LibraryProvider, LibraryPicker };